module.exports = __webpack_public_path__ + "img/d200804-2.02e759be.jpg";